import HatenaCommentList from './HatenaCommentList.vue'
import axios from 'axios'

export default {
    name: 'HatenaCommentList',
    components: {
        HatenaCommentList
    },
    data() {
        let commentList = [];
        return {
            commentList: commentList,
        }
    },
    props: ['code', 'url'],
    created() {
        this.loadCommentList(this.code);
    },
    computed: {
        hatenaUrl: function () {
            return "https://b.hatena.ne.jp/entry?mode=more&url=" + encodeURIComponent(this.url);
        }
    },
    methods: {
        loadCommentList: function (code) {
            axios.get('/comment/hatena', {
                params: {
                    'code': code
                }
            })
                .then((response) => {
                    this.commentList = [];
                    for (let commentData of response.data.commentList) {
                        let comment = {
                            service: "hatena",
                            owner: commentData.user,
                            ownerUrl: "https://b.hatena.ne.jp/" + commentData.user,
                            body: commentData.comment,
                            timestamp: commentData.timestamp,
                        };
                        this.commentList.unshift(comment);
                    }
                });
        }
    }
}

